import { useTranslation } from 'react-i18next';
import TrophyBadge from './TrophyBadge';
import {
  SectionWrapper,
  SectionTitle,
  SectionSubtitle,
  LevelRow,
  LevelItem,
} from './styled-components';

const LevelOverviewSection = ({ levelSummaries }) => {
  const { t } = useTranslation('gamification');

  return (
    <SectionWrapper>
      <SectionTitle>{t('levelOverviewTitle')}</SectionTitle>
      <SectionSubtitle>{t('levelOverviewSubtitle')}</SectionSubtitle>
      <LevelRow>
        {levelSummaries.map((level) => {
          const reached = level.count > 0;

          return (
            <LevelItem key={level.levelKey}>
              <TrophyBadge
                categoryId={null}
                trophyColor={level.levelKey}
                dimmed={!reached}
                numberOverlay={level.count}
              />
            </LevelItem>
          );
        })}
      </LevelRow>
    </SectionWrapper>
  );
};

export default LevelOverviewSection;
